<template>

    <vue-json-editor
            v-model="resultInfo"
            :showBtns="false"
            :mode="jMode"
            lang="zh"
            @json-change="onJsonChange"
            @json-save="onJsonSave"
         />

</template>
<script>
    import vueJsonEditor from 'vue-json-editor'

    export default {
        props: {
            jData: Object,
            jMode:String,
        } ,
        watch: {
            jData: {

                handler(n, o) {
                    this.jsonDataLoad(n);

                },
                //deep:true// 深度监听父组件传过来对象变化
            },
        },
        data () {
            return {
                resultInfo: {},
            }
        },

        components: {
            vueJsonEditor
        },

        methods: {
            jsonDataLoad (json) {
                this.resultInfo=json;
            },
            getJsonData () {
              return  this. resultInfo;
            },
            onJsonChange (value) {
               // console.log('value:', value);
            },
            onJsonSave (value) {
               // console.log('value:', value);
            },

        }
    }

</script>

<style>

    /* jsoneditor右上角默认有一个链接,加css去掉了 */
    .jsoneditor-poweredBy{
        display: none;
    }



    .jsoneditor-vue {
        height: 100%;
        border: 0px solid #dee1e4;
        overflow: no;
    }
    .jsoneditor {
        margin: 0px;
        color: #0f331f;
        border: 0px solid #85abb8 !important;
    }

    .jsoneditor-outer {
        color: #0f331f;
        background-color: #ddcc9b;
    }
    .jsoneditor-tree {
        background-color: #ffffff;
        color: #0f331f;
    }



</style>